export default "__VITE_ASSET__xry1CKc7__"